module.exports = __webpack_public_path__ + "fonts/email@2x.ff63715444ed7aca855414bcd376e89e.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/email@2x.png
// module id = 733
// module chunks = 9